import { NgModule } from '@angular/core';
import { CartFlowTypeResolver } from './resolvers/cart-flow-type.resolver';
import { FlowTypeService } from './services/flow-type.service';

@NgModule({
    providers: [FlowTypeService, CartFlowTypeResolver],
})
export class FlowTypeModule {}
